module.exports = __webpack_public_path__ + "intro2.svg?33b08e874066cde95526f99661f3ed08";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro/intro2.svg
// module id = 62
// module chunks = 0